// frontend_react/src/pages/receipt/ReceiptPage.jsx

import React from 'react';
import { ReceiptProvider } from '../../context/ReceiptContext';
import ReceiptComponent from '../../components/paymodal/Receipt';

/**
 * Wrapper de page ticket : authentification + contexte + affichage
 */
export default function ReceiptPageWrapper() {
  return (
      <ReceiptProvider>
        {/* Affiche le ticket final avec détails TVA et mentions légales */}
        <ReceiptComponent showVatDetail={true} showLegalMentions={true} />
      </ReceiptProvider>
  );
}
